import { Component, OnInit, ViewChild } from '@angular/core';
import { DspxCardSetBaseFormComponent, SpinnerService, DialogService, CoreService } from 'dspx-core';
import { NavigationExtras, Router } from '@angular/router';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { FILTER_QUESTION_CODES, FORM_ACTIONS, NAV_TAB_NUMBERS, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, REFERENCE_DATA_IDS, SAVE_RESULT_STATUS, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { ApplicationGridFilterRequest } from 'src/app/interfaces/application-grid-filter-request.interface';
import { Mapper, MapperBuilder, TRANSFORM } from '../../helpers/mapper';
import { CareAllowanceApplicationGridFilterRequest } from 'src/app/interfaces/care-allowance-application-grid-filter-request.interface';
import { ErrorService } from 'src/app/services/error.service';
import { finalize, take } from 'rxjs';

@Component({
  selector: 'app-care-allowance--application-list',
  templateUrl: './care-allowance-application-list.component.html',
  styleUrls: ['./care-allowance-application-list.component.scss']
})
export class CareAllowanceApplicationListComponent extends BaseCardSetListComponent implements OnInit {

  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';
  selectedApplicationItems: any[] = [];

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.careAllowanceApplicationList,
      () => API_ENDPOINTS.dashboard.getCareAllowanceApplications,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.applicationReferenceNumberFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.applicationTypeFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.applicationStatusFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.applicationAssignedToFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.applicationSubmittedOnFromFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.applicationSubmittedOnToFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.onHoldReasonFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.carerFirstNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.carerLastNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.crisClientIDFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.crisspClientIDFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.clientFirstNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.clientLastNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowanceApplicationListForm.applicationSourceFilter)
        .BuildMapper();
  }

  ngOnInit(): void {
  }

  formLoad(event: any): void {
    if (history.state.applicationFilterRequest == null) {
      this.loadGridDataOnFormLoad();
    }
    else {
      this.loadGridDataOnFormLoad(history.state.applicationFilterRequest);
    }
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.careAllowanceApplicationListForm.applicationListFilter:
      case QUESTION_CODES.careAllowanceApplicationListForm.applicationQuickSearchTerm:
        {
          const applicationFilterRequest = this.getApplicationFilterRequest();
          this.loadGridData(applicationFilterRequest);
          break;
        }
    }
  }

  actionButton_applicationPlaceholder_datagrid_view_Clicked(event: any): void {
    this.viewEditApplication(event);
  }

  actionButton_applicationPlaceholder_datagrid_edit_Clicked(event: any): void {
    this.viewEditApplication(event);
  }

  private viewEditApplication(event: any): void {
    const navExtras = this.getNavigationExtras();
    switch (event.event.data.applicationTypeId) {
      case REFERENCE_DATA_IDS.applicationType.createCarer:
      case REFERENCE_DATA_IDS.applicationType.updateCarer:
        this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceApplication.prefix, ROUTE_CONSTANTS.applicationDetailCreateUpdateCarer.prefix, event.event.data.id], navExtras);
        break;
      case REFERENCE_DATA_IDS.applicationType.createPlacement:
      case REFERENCE_DATA_IDS.applicationType.updatePlacement:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementStartEndDate:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementOneOffPayment:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementTransfer:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementTargetedCarePackage:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementCopStatusChange:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementClientDetails:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementCareAllowanceLevel:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementRespiteContinueToPay:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementMultipleElements:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementCancelPlacement:
      case REFERENCE_DATA_IDS.applicationType.updatePlacementRecallPlacement:
        this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceApplication.prefix, ROUTE_CONSTANTS.applicationDetailCreateUpdatePlacement.prefix, event.event.data.id], navExtras);
        break;
    }
  }

  actionButton_applicationPlaceholder_datagrid_custom_bulkAssign_Clicked(customEvent: any): void {
     this.selectedApplicationItems = customEvent.event.data.selectedItems || [];
    
    if (!this.selectedApplicationItems || this.selectedApplicationItems.length === 0) {
     this.showApplicationSelectionAlert();
     return;
    }

    this.activeDialog = POP_UP_CODES.vptasApplicationDetails.bulkAssignApplicationUserPopup;
    this.dialogService.showDialog(this.activeDialog);
  }
      
  dialogButton_bulkAssignApplicationUserPopup_Clicked($event: any): void {
    
    if (!$event || !$event.assignedToUserIdPopup) {
      return;
    }
    
    const ids = this.selectedApplicationItems.map(r => r.id);
    const request = {
      ids: ids,
      assignedToUserId: $event.assignedToUserIdPopup
    };
    
    this.spinnerService.showSpinner();
    this.appDataService.post(API_ENDPOINTS.careAllowancePlacement.bulkAssign, request)
      .pipe(
        take(1), 
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .subscribe((response) => {
        this.onBulkAssignSuccess(response);
      });
  }
  
  onBulkAssignSuccess(response: any) {
    this.spinnerService.hideSpinner();
    if (response?.status === SAVE_RESULT_STATUS.success) {
      this.dialogService
        .showSimplePopup("Application(s) assigned successfully.", "Success!", "Ok")
        .subscribe(() => {
          const filterRequest = this.getApplicationFilterRequest();
          this.loadGridDataOnFormLoad(filterRequest);
        });
    }
  }

    showApplicationSelectionAlert() {
    this.dialogService
      .showSimplePopup("Please select at least one application.", "Application Alert!", "Ok")
      .subscribe(
        result => {
        }
      );
  }
  private getApplicationFilterRequest(): ApplicationGridFilterRequest {
    const applicationFilterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.careAllowanceApplicationListForm.applications,
      PAGE_NUMBERS.careAllowanceApplicationListForm.applications,
      SECTION_CODES.careAllowanceApplicationListForm.application,
      QUESTION_CODES.careAllowanceApplicationListForm.applicationListFilter
    );

    let filterRequest: ApplicationGridFilterRequest = this.filterQuestionToFilterModelMapper.Map(applicationFilterModel);

    filterRequest.applicationQuickSearchTerm = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.careAllowanceApplicationListForm.applications,
      PAGE_NUMBERS.careAllowanceApplicationListForm.applications,
      SECTION_CODES.careAllowanceApplicationListForm.application,
      QUESTION_CODES.careAllowanceApplicationListForm.applicationQuickSearchTerm
    );

    return filterRequest;
  }

   private getFilterRequest(): CareAllowanceApplicationGridFilterRequest {
      const filterModel = this.getQuestionValue(
        this.model,
        NAV_TAB_NUMBERS.careAllowanceApplicationListForm.applications,
        PAGE_NUMBERS.careAllowanceApplicationListForm.applications,
        SECTION_CODES.careAllowanceApplicationListForm.application,
        QUESTION_CODES.careAllowanceApplicationListForm.applicationListFilter
      );
  
      let filterRequest: CareAllowanceApplicationGridFilterRequest = this.filterQuestionToFilterModelMapper.Map(filterModel);
  
      return filterRequest;
    }

    private getNavigationExtras(): NavigationExtras {
      const filterRequest = this.getFilterRequest();
  
      return {
        state: {
          applicationFilterRequest: filterRequest
        }
      };
    }
}
